import {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";
import { useForm } from "react-hook-form";
import { v4 as uuid } from "uuid";

import { mockApiData } from "../../services/mockApi/mockApi";
import { getCityFromUf, getUfsAll } from "../../services/apis/ibgeApi";

import styles from "./style.module.scss";

import Dialog from "@mui/material/Dialog";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

import Filters from "../../libs/filters/Filters";

import { ContextApi } from "../../context/contextApi";
import { DrawerContext } from "../../context/drawerContext";
import { SwitchMui } from "../../libs/inputs/switchMui";
import { SelectOrRegister } from "../../libs/inputs/selectOrRegister";
import { Upload } from "../../libs/inputs/uploadImage";

export function InnerCameraModal() {
  const {
    getRegions,
    allEstadosOrdering,
    allRegions,
    getCameras,
    createCamera,
  } = useContext(ContextApi);
  const { showInnerCamera, setShowInnerCamera } = useContext(DrawerContext);
  const {
    register,
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const countries = useMemo(() => {
    if (allEstadosOrdering.length === 0) {
      return [];
    }
    let arrayCountries = [];
    allEstadosOrdering.forEach((element) => {
      arrayCountries.push({
        id: element.id,
        label: element.estado_sigla,
        description: element.nome,
      });
    });
    return arrayCountries;
  }, [allEstadosOrdering]);
  const [city, setCity] = useState(null);
  const [showAadvancedInformations, setShowAadvancedInformations] =
    useState(false);
  const [referency, setReferency] = useState("");
  const [ufSelected, setUfSelected] = useState("");
  const [switchResult, setSwitchResult] = useState(true);
  const [switchAdAnuncio, setSwitchAdAnuncio] = useState(false);
  const [imageLogoDireitaB64, setImageLogoDireitaB64] = useState("");
  const [imageLogoEsquerdaB64, setImageLogoEsquerdaB64] = useState("");
  const [imagePosterB64, setImagePosterB64] = useState("");
  const [switchShowAnuncioUmaVez, setSwitchShowAnuncioUmaVez] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [imagePlanoFundoB64, setImagePlanoFundoB64] = useState("");
  const [ufSelect, setUfSelect] = useState("");
  const [citySelect, setCitySelect] = useState("");
  const [availability, setAvailability] = useState("");
  const [selectPrediction, setSelectPrediction] = useState("");
  const [errorId_stream, setErrorId_stream] = useState(false);
  const [errorName, setErrorName] = useState(false);
  const [errorUf, setErrorUf] = useState(false);
  const [errorCity, setErrorCity] = useState(false);
  const [errorRegion, setErrorRegion] = useState(false);

  function clearStatsForm() {
    setSelectedRegion(null);
    setValue("name", "");
    setValue("id_stream", "");
    setValue("establishment", "");
    setValue("establishmentLink", "");
    setValue("Embed", "");
    setReferency("");
    setValue("description", "");
    setAvailability("");
    setValue("prediction", mockApiData.prediction);
    setShowAadvancedInformations(false);
    setUfSelect("");
    setCitySelect("");
  }
  const [allowCityType, setAllowCityType] = useState(false);
  const referenceInput = useCallback((inputElement) => {
    if (inputElement) {
      inputElement.focus();
    }
  }, []);

  async function getCity() {
    let arrayCities = [];
    const ufFromUfSelect = countries?.find((uf) => uf.id === Number(ufSelect));
    if (ufFromUfSelect) {
      await getCityFromUf(ufFromUfSelect.label)
        .then((response) =>
          response.data.map((city) => {
            return arrayCities.push({
              id: city.id,
              description: city.nome,
            });
          })
        )
        .catch((err) => console.log(err));
      setCity(arrayCities);
      setAllowCityType(
        ["Panamá", "El Salvador", "Peru"].includes(ufFromUfSelect.description)
      );
    }
  }

  const onSubmit = async (body) => {
    let cidadeFilter = city.filter((ret) => ret.id === Number(citySelect));
    let ufFilter = countries.filter((retUf) => retUf.id === Number(ufSelect));
    if (body.id_stream === "") {
      setErrorId_stream(true);
    } else {
      setErrorId_stream(false);
    }
    if (body.name === "") {
      setErrorName(true);
    } else {
      setErrorName(false);
    }
    if (!citySelect) {
      setErrorCity(true);
    } else {
      setErrorCity(false);
    }
    if (!ufSelect) {
      setErrorUf(true);
    } else {
      setErrorUf(false);
    }
    if (!selectedRegion) {
      setErrorRegion(true);
    } else {
      setErrorRegion(false);
    }
    if (
      body.id_stream &&
      body.name &&
      cidadeFilter[0].description &&
      ufFilter[0].label &&
      ufFilter[0].description &&
      selectedRegion.idSelected
    ) {
      await createCamera({
        stream_id: body.id_stream,
        estado_sigla: ufFilter[0].label,
        estado_imagem: "",
        estado: ufFilter[0].description,
        area_regiao_id: selectedRegion.idSelected,
        cidade: cidadeFilter[0].description,
        nome_camera: body.name,
        parceiro: body.establishment ? body.establishment : "",
        parceiro_link: body.establishmentLink ? body.establishmentLink : "",
        stream_hls: "",
        referencia: referency ? referency : "",
        status: true,
        visibilidade: switchResult ? switchResult : true,
        digest: "",
        marca_dagua_superior_direito: imageLogoDireitaB64
          ? imageLogoDireitaB64
          : null,
        marca_dagua_superior_esquerdo: imageLogoEsquerdaB64
          ? imageLogoEsquerdaB64
          : null,
        poster: imagePosterB64 ? imagePosterB64 : null,
        previsao_metereologica: selectPrediction ? selectPrediction : "",
        previsao_metereologica_resumo: "",
        descricao: body.description ? body.description : "",
        ad_anuncio: switchAdAnuncio ? switchAdAnuncio : false,
        ad_anuncio_single: switchShowAnuncioUmaVez
          ? switchShowAnuncioUmaVez
          : false,
        disponibilidade: availability !== "" ? availability : "Free",
        embeded_monuv: body.Embed ? body.Embed : "",
        logo: imagePlanoFundoB64 ? imagePlanoFundoB64 : null,
      }).then((response) => {
        handleCloseInnerCamera();
        getCameras();
        clearStatsForm();
      });
    }
  };

  function handleCloseInnerCamera() {
    setShowInnerCamera(false);
    setShowAadvancedInformations(false);
    setErrorId_stream(false);
    setErrorName(false);
    setErrorUf(false);
    setErrorCity(false);
    setErrorRegion(false);
  }

  const Input = ({ label, register, required, registerName, error }) => (
    <div className={error ? styles.inputTextError : styles.inputText}>
      <label>{label}</label>
      {error && <span>*Informação obrigatória</span>}
      <input {...register(registerName, { required })} />
    </div>
  );

  const InputMask = ({ label }) => (
    <div className={styles.inputText}>
      <label>{label}</label>
      <input
        value={Filters.removSpacesAndAccents(referency)}
        onChange={(e) =>
          setReferency(Filters.removSpacesAndAccents(e.target.value))
        }
        ref={referenceInput}
      />
    </div>
  );

  const Select = ({
    onChange,
    onBlur,
    name,
    label,
    options,
    styleOne,
    value,
    error,
  }) => (
    <>
      {styleOne && (
        <div className={styleOne}>
          <label>{label}</label>
          {error && <span>*Informação obrigatória</span>}
          <select name={name} onChange={onChange} onBlur={onBlur} value={value}>
            {options.map((options) => {
              return (
                <option value={options.id ? options.id : options.label}>
                  {options.description}
                </option>
              );
            })}
          </select>
        </div>
      )}
      {!styleOne && (
        <div className={error ? styles.inputTextError : styles.inputText}>
          <label>{label}</label>
          {error && <span>*Informação obrigatória</span>}
          <select name={name} onChange={onChange} onBlur={onBlur} value={value}>
            {options.map((options) => {
              return (
                <option value={options.id ? options.id : options.label}>
                  {options.description}
                </option>
              );
            })}
          </select>
        </div>
      )}
    </>
  );

  function handleSelectedUf() {
    if (countries) {
      let ufFilter = countries.filter((retUf) => retUf.id === Number(ufSelect));
      setUfSelected(ufFilter[0]?.label);
    }
  }

  useEffect(() => {
    getRegions();
  }, []);

  useEffect(() => {
    getCity();
    handleSelectedUf();
  }, [ufSelect]);

  return (
    <Dialog
      onClose={handleCloseInnerCamera}
      open={showInnerCamera}
      className={styles.dialogModalContainer}
    >
      <div className={styles.headerModalInnerCamera}>
        <span>
          Inserir nova câmera
          <p>Preencher o máximo possível</p>
        </span>
        <CancelPresentationIcon
          alt="Cancelar Operação"
          onClick={handleCloseInnerCamera}
        />
      </div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={styles.containerFormModal}
      >
        <Input
          label="id do stream"
          registerName="id_stream"
          register={register}
          error={errorId_stream}
        />
        <Input
          label="Nome da Camera"
          registerName="name"
          register={register}
          error={errorName}
        />
        <Select
          options={mockApiData.availability}
          label="Disponibilidade"
          name="Disponibilidade"
          value={availability}
          onChange={(e) => setAvailability(e.target.value)}
        />
        <div className={styles.boxUFCity}>
          <Select
            options={countries}
            label="Estado?"
            name="UF"
            value={ufSelect}
            onChange={(e) => setUfSelect(e.target.value)}
            styleOne={
              errorUf
                ? styles.inputTextNotMarginError
                : styles.inputTextNotMargin
            }
            error={errorUf}
          />
          {!allowCityType && city && (
            <Select
              options={city}
              label="Cidade?"
              nome="cidade"
              value={citySelect}
              onChange={(e) => setCitySelect(e.target.value)}
              styleOne={
                errorCity
                  ? styles.inputTextNotMarginError
                  : styles.inputTextNotMargin
              }
              error={errorCity}
            />
          )}
          {allowCityType && (
            <Input label="Cidade?" registerName="city" register={register} />
          )}
        </div>
        <SelectOrRegister
          error={errorRegion}
          label="Qual área?"
          titleInput="Selecione ou cadastre uma nova região"
          dataRegions={allRegions || []}
          ufSelected={ufSelected}
          setSelectedRegion={setSelectedRegion}
          selectedRegion={selectedRegion}
        />
        <Input
          label="Nome do estabelecimento parceiro?"
          registerName="establishment"
          register={register}
        />
        <Input
          label="Link do estabelecimento parceiro?"
          registerName="establishmentLink"
          register={register}
        />
        <Select
          options={mockApiData.prediction}
          label="Que previsão vai ficar?"
          nome="prediction"
          value={selectPrediction}
          onChange={(e) => setSelectPrediction(e.target.value)}
        />
        <Input label="Embed Monuv?" registerName="Embed" register={register} />
        <div
          className={styles.boxBTNAdvancedInformation}
          onClick={() =>
            setShowAadvancedInformations(!showAadvancedInformations)
          }
        >
          <span>Informações avançadas</span>
          {!showAadvancedInformations ? (
            <ArrowDropDownIcon />
          ) : (
            <ArrowDropUpIcon />
          )}
        </div>
        {showAadvancedInformations && (
          <>
            {/* <InputMask  
                        label="Referência" 
                        /> */}
            <Input
              label="Descrição"
              registerName="description"
              register={register}
            />
            <div className={styles.boxSwitch}>
              <SwitchMui
                optionSwitchCheck="OnLine"
                optionSwitchUncheck="OffLine"
                label="Visibilidade"
                switchResult={switchResult}
                setSwitchResult={setSwitchResult}
              />
              <SwitchMui
                optionSwitchCheck="Sim"
                optionSwitchUncheck="Não"
                label="Add anuncio"
                switchResult={switchAdAnuncio}
                setSwitchResult={setSwitchAdAnuncio}
              />
            </div>
            <div className={styles.boxSwitch}>
              <SwitchMui
                optionSwitchCheck="Sim"
                optionSwitchUncheck="Não"
                label="Mostrar anúncio apenas uma vez?"
                switchResult={switchShowAnuncioUmaVez}
                setSwitchResult={setSwitchShowAnuncioUmaVez}
              />
            </div>
            <Upload
              labelUploadImage="Logo esquerda"
              imageB64={imageLogoEsquerdaB64}
              setImageB64={setImageLogoEsquerdaB64}
              allTypesImage={false}
            />
            <Upload
              labelUploadImage="Logo direita"
              imageB64={imageLogoDireitaB64}
              setImageB64={setImageLogoDireitaB64}
              allTypesImage={false}
            />
            <Upload
              labelUploadImage="Poster"
              imageB64={imagePosterB64}
              setImageB64={setImagePosterB64}
              allTypesImage={true}
            />
            <Upload
              labelUploadImage="Plano de fundo"
              imageB64={imagePlanoFundoB64}
              setImageB64={setImagePlanoFundoB64}
              allTypesImage={true}
            />
          </>
        )}
        <div className={styles.boxBTNSubmit}>
          <input type="submit" />
        </div>
      </form>
    </Dialog>
  );
}
